/** True when pathname is an open EMR encounter (e.g. .../patient-care/emr/288/51). */
export function isEmrRoute(pathname: string): boolean {
  return /\/patient-care\/emr\/\d+/i.test(pathname);
}
